export const FAQ_INPUT_SEARCH_MAX_CHARACTERS = 80

export const FAQ_INPUT_SEARCH_MIN_CHARACTERS = 3

export const FAQ_CATEGORIES = {
  TECHNICAL_SUPPORT: 'TECHNICAL_SUPPORT',
  PAYMENT: 'PAYMENT',
  WIFI: 'WIFI',
  PRODUCTS: 'PRODUCTS',
  CENTRAL_ASSINANTE: 'CENTRAL_ASSINANTE',
  OTHER: 'OTHER',
}

export const FAQ_STAGES = {
  INITIAL: 'initial',
  CATEGORY: 'category',
}
